import React, { useState, useEffect } from "react";
import { Dropdown, Modal } from "antd";
import {
    useAccount,
    useConnect,
    useDisconnect,
} from "wagmi";
import "./style.css"
import { useWeb3Modal } from '@web3modal/wagmi/react'
import { useWeb3ModalState } from '@web3modal/wagmi/react'
import Web3 from "web3";
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../../actions';
import { ethers } from "ethers";
import IconClose from '../asset/images/icon-close.svg';
import IconKDG from '../asset/images/logo-new.svg';
import IconCopy from '../asset/images/icon-copy.svg';
import Rank1 from '../asset/images/rank-1.png';
import Rank2 from '../asset/images/rank-2.png';
import Rank3 from '../asset/images/rank-3.png';
import Rank4 from '../asset/images/rank-4.png';
import Rank5 from '../asset/images/rank-5.png';
import { Tokens } from "../../../constants";
import { useHook } from './store'


const formatNumber = (x, max) => {
    if (x) {
        return x.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: max,
        });
    } else return 0;
};

const WagmiConnect = (props) => {
    const [state, actions] = useHook();
    const [myBalance, setMyBalance] = useState(0);
    const [amountStaking, setAmountStaking] = useState(0);
    const [tierName, setTierName] = useState('');
    const { open } = useWeb3Modal()
    const { selectedNetworkId } = useWeb3ModalState()
    const chainId = selectedNetworkId;

    const { address, isConnected } = useAccount();
    const dispatch = useDispatch();
    const { disconnect } = useDisconnect();
    const [infoWallet, setInfoWallet] = useState(false);
    const provider = "https://data-seed-prebsc-1-s1.binance.org:8545/";
    const web3 = window.ethereum ? new Web3(window.ethereum) : new Web3(provider);



    const handleDisconnect = () => {
        disconnect();
        // dispatch(allActions.userActions.setUser(null));
        // dispatch(allActions.userActions.setChainId(null));
        // setIsModalVisible(false);
        // window.location.reload();
    };

    const handleConnectWagmi = () => {
        open();
        // props.onClose(false);
        // window.location.reload();
    }
    const currentUser = useSelector(state => state.currentUser);

    const accountEllipsis = address ? `${address.substring(0, 4)}...${address.substring(address.length - 4)}` : '';

    const infoStake = useSelector(state => state.currentUser.infoStake);


    useEffect(() => {
        if (address) {
            dispatch(allActions.userActions.setCurrentUser({ "address": address }));
            dispatch(allActions.authAction.getAuthToken({ "address": address }));
        }
    }, [address]);

    useEffect(() => {
        if (address && currentUser.b) {

            localStorage.setItem(Tokens.AUTHUSER, currentUser && currentUser.b);
            dispatch(allActions.authAction.getAuthKey({ "address": address }));
        }
    }, [address, currentUser.b]);

    useEffect(() => {
        if (address) {
            const loadBalance = async () => {
                const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
                const kdg = {
                    address: "0x87a2d9a9a6b2d61b2a57798f1b4b2ddd19458fb6",
                    abi: [
                        "function name() view returns (string)",
                        "function symbol() view returns (string)",
                        "function gimmeSome() external",
                        "function balanceOf(address _owner) public view returns (uint256 balance)",
                        "function transfer(address _to, uint256 _value) public returns (bool success)",
                    ],
                };
                await provider.send("eth_requestAccounts", []);
                const signer = provider.getSigner();
                const kdgContract = new ethers.Contract(kdg.address, kdg.abi, signer);
                let kdgBalance = await kdgContract.balanceOf(address);
                setMyBalance(ethers.utils.formatEther(kdgBalance, 6));
            }

            loadBalance();
        }

    }, [address]);


    let copyWallet = null;
    const copyToClipboard = () => {
        copyWallet.select();
        document.execCommand("copy");
    };

    const dataRank = [
        { title: 'Star', rank: '100,000 KDG', img: Rank1 },
        { title: 'Mercury', rank: '200,000 KDG', img: Rank2 },
        { title: 'Venus', rank: '400,000 KDG', img: Rank3 },
        { title: 'Earth', rank: '800,000 KDG', img: Rank4 },
        { title: 'Mars', rank: '1,500,000 KDG', img: Rank5 }
    ];

    const elmRank = dataRank.map((item, key) => {
        return (
            <li key={key} className={tierName === item.title ? 'is-active' : ''}>
                <img src={item.img} alt={item.title} />
                <p>{item.title}<span>{item.rank}</span></p>
            </li>
        )
    });

    const onCancelWallet = () => {
        setInfoWallet(false);
    }
    const showInfoWallet = () => {
        setInfoWallet(true);
    }

    async function getDataStakeUser() {
        try {
            await actions.getStake(address).then((res) => {
                setAmountStaking(res?.staking)
                setTierName(res?.tierName)
            })
                .catch((err) => {
                    setAmountStaking(0)
                    setTierName("")
                })
        } catch (error) {
            setAmountStaking(0)
            setTierName("")
            console.log('error', error)
        }
    }

    useEffect(() => {
        if (address) {
            getDataStakeUser()
        } else {
            setAmountStaking(0)
            setTierName("")
        }

    }, [address])


    const items = (
        <>
            {infoWallet && (
                <div className="c-popup">
                    <div className="c-popup__box">
                        <div className="c-popup__head">
                            Wallet
                            <button className="c-popup__close" onClick={onCancelWallet}><img src={IconClose} alt="Close" /></button>
                        </div>
                        <div className="c-popup__body">
                            <div className="c-infoWallet">
                                <div className="c-infoWallet__logo">
                                    <div className="bg-logo">
                                        <img src={IconKDG} alt="KDG" />
                                    </div>
                                    <p>KDG Balance<span>{myBalance > 0 ? parseFloat(myBalance).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '0.0'}</span></p>
                                </div>
                                <div className="c-infoWallet__row">
                                    <span>Wallet Address:</span>
                                    <p>
                                        {accountEllipsis}
                                        <input readOnly value={address} ref={(ref) => (copyWallet = ref)} />
                                        <button onClick={() => copyToClipboard()}><img src={IconCopy} alt="Copy" /></button>
                                    </p>
                                </div>
                                <div className="c-infoWallet__row">
                                    <span>Staking:</span>
                                    <p>{formatNumber(amountStaking, 1)} KDG</p>
                                </div>
                                <div className="c-infoWallet__row">
                                    <span>Tier:</span>
                                    <p>{tierName ? tierName : '--'}</p>
                                </div>
                                <ul className="c-infoWallet__rank">
                                    {elmRank}
                                </ul>
                                <p className="c-infoWallet__txt">
                                    You don't have sufficient KDG token
                                    <span><a href="#">Swap Now</a></span>
                                </p>
                                <div className="c-infoWallet__btn">
                                    <a className="c-btn c-btn--border" href={`https://bscscan.com/address/${address}`} target="_blank" rel="noreferrer">View on Bscscan</a>
                                    <button className="c-btn" onClick={() => handleDisconnect()}>Sign out</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )

    return (
        <>
            {isConnected ? (
                <>

                    <Dropdown
                        trigger={['click']}
                        overlay={
                            items
                        }
                        placement="bottomRight"
                    >
                        <button className={`c-btnWallet`} onClick={showInfoWallet}>
                            <>
                                {address?.substring(0, 4)}...{address?.substring(address.length - 4)}
                            </>
                        </button>
                    </Dropdown>
                </>
            ) : (
                <>
                    <button className="c-btnWallet" onClick={handleConnectWagmi}>
                        <img src="../../../images/bot/wallet-money.png" alt="" /> Connect Wallet
                    </button>
                </>
            )}

        </>
    );
};
export default WagmiConnect;


